import React from "react";
import "../../assets/style/eegisterProvider.css";
import YourDataUnitTable from "../../components/Table/YourDataUnitTable";
const Yourdata = () => {
  return (
    <div style={{ width: "100%", backgroundColor: "#F3F4F8" }}>
     
     <div style={{ display: "flex", justifyContent: "center",flexDirection:"column" }}>    
       <span >
        <div style={{ padding:20, fontSize:30,fontWeight:"bold" }}>
          <span >Tokenized Fund-Units</span>
          <></>
        </div>
      </span>
        <div
          style={{
            display: "flex",
            backgroundColor: "white",
            padding: 30,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-around",
            width: "90%",
          }}
        >
          <div style={{ width: "98%", marginTop: 40 }}>
            <YourDataUnitTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Yourdata;
